import React from 'react';
import './style.sass';

type FullWrapperPropsType = {
    children: React.ReactNode;
    className?: string;
    smallPaddings?: boolean;
    isMargin?: boolean;
    bigPaddings?: boolean;
};

const FullWrapper = ({
    children,
    className = '',
    smallPaddings = false,
    isMargin = true,
    bigPaddings = false,
}: FullWrapperPropsType) => {
    let isMarginStr = '';
    if (!isMargin) {
        isMarginStr = 'case__item--is-marginless';
    }

    let isSmallPaddingsStr = '';
    if (smallPaddings && !bigPaddings) {
        isSmallPaddingsStr = 'case__item--small-paddings';
    }

    let isBigPaddingsStr = '';
    if (bigPaddings && !smallPaddings) {
        isBigPaddingsStr = 'case__item--big-paddings';
    }

    return (
        <div
            className={`case__item ${className} ${isSmallPaddingsStr} ${isMarginStr} ${isBigPaddingsStr}`}
        >
            <div className="full-wrapper">{children}</div>
        </div>
    );
};

export default FullWrapper;
